
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { LeadStatusBadge } from './LeadStatusBadge';
import { StatusSelectProps } from './types';

export function LeadStatusSelect({ leadId, status, updatingStatus, onStatusChange }: StatusSelectProps) {
  return (
    <Select
      value={status}
      onValueChange={(value) => onStatusChange(leadId, value)}
      disabled={updatingStatus === leadId}
    >
      <SelectTrigger className="w-[140px]">
        <SelectValue>
          <div className="flex items-center space-x-2">
            {updatingStatus === leadId ? (
              <div className="h-4 w-4 animate-spin rounded-full border-2 border-grandpal-green border-t-transparent" />
            ) : (
              <LeadStatusBadge status={status} />
            )}
          </div>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectItem value="interested">Interested</SelectItem>
          <SelectItem value="to_visit">To Visit</SelectItem>
          <SelectItem value="visit_scheduled">Visit Scheduled</SelectItem>
          <SelectItem value="visited">Visited</SelectItem>
          <SelectItem value="shortlisted">Shortlisted</SelectItem>
          <SelectItem value="application_submitted">Application Submitted</SelectItem>
          <SelectItem value="waitlist">On Waitlist</SelectItem>
          <SelectItem value="declined">Declined</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
